<template>
  <div class="monit-page wrapper-cards">
    <div class="container-cards">
      <!-- MANAGEMENT CARDS  -->
      <farms-status-card
        v-for="farm in farmsStatus"
        :key="farm.port"
        :item="farm"
      />
    </div>
  </div>
</template>

<script>
import FarmsStatusCard from "./components/FarmsStatusCard.vue";
import { scripts } from "@/api";

export default {
  components: {
    FarmsStatusCard
  },
  data() {
    return {
      farmsStatus: [],
    }
  },
  created() {
    scripts.get_farms_status()
    .then(farmsStatus => {
      this.farmsStatus = farmsStatus;

      return farmsStatus;
    })
  },
}
</script>

<style scoped>
.water-icon-excess {
  color: #2997a8 !important;
}

.wrapper-cards {
  overflow: auto !important;
}

.monit-sector-main {
  width: 100%;
  transition: 0.1s;
  overflow-y: auto;
  height: 100%;
  margin: 0;
}
.card-icon {
  color: #9e9e9e;
  font-size: 13px;
}
.measure-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EmptyRequest {
  width: 100%;
  padding: 10px;
  color: Black;
  font-size: 1.1rem;
  text-align: center;
}
.my-class {
  padding: 0;
}
.monitCard {
  min-height: 180px;
}
.filter-model {
  max-height: 180px;
  overflow-y: auto;
  overflow-x: hidden;
}

.badge-3v3 {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-3v3 * {
  font-size: 20px;
}
</style>
